const rwaData = [
  {
    "region": "Americas",
    "assets": [
      {
        "name": "VERT Agricultural Receivables",
        "issuer": "rsj2HzZNaQNihtX2nPJSxVZuUBrNSCMYXi",
        "currency": "VRT",
        "unitsIssued": 139125000,
        "navPrice": 1.24,
        "navPriceCurrency": "USD",
        "exchangeRate": 0.79,
        "city": "São Paulo",
        "lat": -23.5505,
        "lng": -46.6333
      },
      {
        "name": "Ondo Finance OUSG",
        "issuer": "rHuiXXjHLpMP8ZE9sSQU5aADQVWDwv6h5p",
        "currency": "OUSG",
        "unitsIssued": 269319,
        "navPrice": 112.06,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "New York",
        "lat": 40.7128,
        "lng": -74.0060
      },
      {
        "name": "Guggenheim + Zeconomy",
        "issuer": "rnXNUqF8LuXyUdfLdezftTeEUw2UFSLw5i",
        "currency": "ZECO",
        "unitsIssued": 10000000,
        "navPrice": 1,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "New York",
        "lat": 40.7128,
        "lng": -74.0060
      }
    ]  
  },
  {
    "region": "Europe, Middle East & Africa", 
    "assets": [
      {
        "name": "Dubai Land Dept + Ctrl Alt",
        "issuer": [
          "rPFRtJ5FB6p3vPDtM5AdsQ6J3X4Mvg9Kei",
          "rDgoZHy4SLPs4jhJZqkyaXX4iEsEUkCAVp"
        ],
        "currency": "DLD",
        "unitsIssued": 21240796,
        "navPrice": 1,
        "navPriceCurrency": "AED",
        "exchangeRate": 0.2723,
        "city": "Dubai",
        "lat": 25.2048,
        "lng": 55.2708
      },
      {
        "name": "CoinMENA",
        "issuer": "rMENAxRE4k2VjH8pL9mQ7Xc3fN6wE8tYzK",
        "currency": "RWAs",
        "unitsIssued": 100000,
        "navPrice": 1,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "Riyadh",
        "lat": 24.7136,
        "lng": 46.6753
      },
      {
        "name": "Archax",
        "issuer": "rKCu4CucpepQ6N89c8T5GuX2jkxzCST18Q",
        "currency": "RWAs", 
        "unitsIssued": 80301333,
        "navPrice": 1,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "London",
        "lat": 51.5074,
        "lng": -0.1278
      }
    ]
  },
  {
    "region": "Asia-Pacific",
    "assets": [
      {
        "name": "OpenEden T-BILLS",
        "issuer": [
          "rJNE2NNz83GJYtWVLwMvchDWEon3huWnFn",
          "rB56JZWRKvpWNeyqM3QYfZwW4fS9YEyPWM"
        ],
        "currency": "OE",
        "unitsIssued": 58778686,
        "navPrice": 1.2796,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "Singapore",
        "lat": 1.3521,
        "lng": 103.8198
      }
    ]
  }
];

export default rwaData;